module.exports = __webpack_public_path__ + "img/logo.70e8e91a.png";